import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appInputLength]',
  standalone: false
})
export class InputLengthDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: any): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const maxLength = 3;


    if(event?.data == "." || event?.data == "-" || event?.data == ","){
      inputElement.value = inputElement.value.slice(0, maxLength);
      event.preventDefault();
    }
    else if (inputElement.value.length > maxLength) {
      inputElement.value = inputElement.value.slice(0, maxLength);
      event.preventDefault();
    }
  }
}